import StudyProgramSkillAbilityFormPageActionTypes from '../actions/study-program-skill-ability-form-page-action-types';

const initialState = {
  loading: false,
  studyProgramId: null,
  studyProgramSkillAbility: {},
  saveSuccess: false,
  validationResult: null,
  cancellationTokenSources: new Map()
};

export default (state = initialState, action) => {
  switch (action.type) {
    case StudyProgramSkillAbilityFormPageActionTypes.LOAD_STUDY_PROGRAM_SKILL_ABILITY_FORM_PAGE_START:
      return {
        ...state,
        loading: true,
        validationResult: null
      };
    case StudyProgramSkillAbilityFormPageActionTypes.LOAD_STUDY_PROGRAM_SKILL_ABILITY_FORM_PAGE_END:
      return {
        ...state,
        loading: false,
        studyProgramId: action.payload?.studyProgramId,
        studyProgramSkillAbility: action.payload ? action.payload.studyProgramSkillAbility : null,
        validationResult: action.payload ? action.payload.validationResult : null
      };
    default:
      return state;
  }
};